import {
  convertValueToLocale,
  convertLocaleValueToNumber,
} from "helpers/convertValueToLocale";

export const getRentPerSqMeter = ({
  aptRentPerMonth,
  aptArea,
}: {
  aptRentPerMonth: string;
  aptArea: string;
}) => {
  if (!aptArea || aptArea === "0") return convertValueToLocale(0, 0, " €/m²");
  if (!aptRentPerMonth || aptRentPerMonth === "0")
    return convertValueToLocale(0, 0, " €/m²");

  return convertValueToLocale(
    convertLocaleValueToNumber(aptRentPerMonth) /
      convertLocaleValueToNumber(aptArea),
    1,
    "€/m²"
  );
};
